import { animate, style, transition, trigger } from '@angular/animations';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit, inject } from '@angular/core';
import { Router } from '@angular/router';
import { routePath } from '@brightside-web/desktop/data-access/core-services';
import { BrightsideUiModule, HeaderLabelCellConfig } from '@brightside/brightside-ui';
import { TranslateModule, TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'brightside-web-credit-pending-card',
    templateUrl: './credit-pending-card.component.html',
    styleUrls: ['./credit-pending-card.component.scss'],
    imports: [BrightsideUiModule, TranslateModule],
    changeDetection: ChangeDetectionStrategy.OnPush,
    animations: [
        trigger('fadeIn', [transition(':enter', [style({ opacity: 0 }), animate('500ms ease-out', style({ opacity: 1 }))])]),
    ]
})
export class CreditPendingCardComponent implements OnInit {
  creditPendingCellConfig: HeaderLabelCellConfig;

  private _router = inject(Router);
  private _translateService = inject(TranslateService);
  private _cdr = inject(ChangeDetectorRef);

  constructor() {}

  ngOnInit(): void {
    this.showRetryAccessoryCard();
  }

  navigateToCreditSetup(): void {    
    this._router.navigate([routePath('credit_setup')]);
  }

  private showRetryAccessoryCard(): void {
    this.creditPendingCellConfig = {
      leftTitle: this._translateService.instant('CREDIT_SCORE'),
      leftTitleSemibold: true,
      bgColor: 'var(--white)',
      minHeight: '2.2rem',
    };
    this._cdr.detectChanges();
  }
}
